import { useParams } from 'react-router-dom';
import Layout from './Layout'
import GameDetails from './GameDetails';
import Breadcrumbs from './Breadcrumbs';

const Game = () => {
  const { id } = useParams();
  return (
      <Layout>
          <Breadcrumbs />
          <GameDetails id={id}/>
      </Layout>
    );
};

export default Game;